var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-ingredients'),_c('choose-ingredients'),_c('cocktail-list',{attrs:{"filteredBy":'ingredients'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }